class GoogleMaps extends HTMLElement {
  constructor() {
    super();
    this.inputType = this.dataset.inputType;
  }
  connectedCallback() {
    this.initMap();
  }
  convertAddressToEmbed(address) {
    return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
  }
  /**
   * Convert Google Maps URL to embed URL
   * @param {string} url - Google Maps URL
   * @returns {string|null} - Embed URL or null if invalid
   */
  convertGoogleMapsToEmbed(url) {
    const placeMatch = url.match(/place\/([^/]+)/);
    let embedUrl = "";
    if (placeMatch) {
      const placeName = decodeURIComponent(placeMatch[1].replace(/\+/g, " "));
      embedUrl = `https://www.google.com/maps?q=${encodeURIComponent(placeName)}&output=embed`;
    } else {
      return null;
    }
    return embedUrl;
  }
  convertToEmbed(value) {
    const input = value.trim();
    if (/^https?:\/\//i.test(input)) {
      return this.convertGoogleMapsToEmbed(input);
    }
    return this.convertAddressToEmbed(input);
  }
  /**
   * Initialize and show the map
   */
  initMap() {
    var _a, _b;
    const input = this.querySelector("[data-map-url]");
    const iframe = this.querySelector("[data-map-iframe]");
    if (!input || !iframe) {
      return;
    }
    const url = ((_a = input.value) == null ? void 0 : _a.trim()) || ((_b = input.getAttribute("value")) == null ? void 0 : _b.trim());
    if (!url) {
      return;
    }
    try {
      let embedUrl = "";
      embedUrl = this.convertToEmbed(url);
      if (!embedUrl) {
        throw new Error("Invalid Google Maps link");
      }
      iframe.src = embedUrl;
    } catch (err) {
    }
  }
}
if (!customElements.get("google-maps-component")) {
  customElements.define("google-maps-component", GoogleMaps);
}
